'use strict';

import _ from 'lodash';
import alt from '../alt';
import { createStore, datasource, bind } from 'alt/utils/decorators';
import WebinarActions from '../actions/webinar.actions';
import WebinarsSource from '../sources/webinars.source';

@createStore(alt)
@datasource(WebinarsSource)
class WebinarsStore {

    constructor() {
        this.upcoming = [];
        this.recent = [];
        this.all = [];
    }

    @bind(WebinarActions.loadAll)
    onLoadAll(props) {
        if (!this.getInstance().isLoading()) {
            this.getInstance().fetch(props);
        }
    }

    @bind(WebinarActions.loadedAll)
    onloadedAll(results) {
        _.each(results, result => {
            result.search_string = '';
            result.search_string += (result.title ? result.title + ' ' : null);
            result.search_string += (result.description ? result.description + ' ' : null);
        });
        let date = parseInt(new Date().getTime() / 1000); // used to separate upcoming and recent events
        this.upcoming = _.filter(results, r => { return r.date > date; });
        this.recent = _.filter(results, r => { return r.date < date; });
        this.all = results;
    }
}

export default WebinarsStore;